"use client"
import { Book, Plus, WandIcon, Loader } from "lucide-react"

export const EmptyCourseView = ({ contentManagement, aiFeatures }) => {
  return (
    <div className="text-center py-10 bg-white rounded-lg border border-dashed border-gray-300 shadow-sm mt-6">
      <Book className="h-12 w-12 text-gray-400 mx-auto mb-2" />
      <h3 className="text-lg font-medium text-gray-900 mb-2">No chapters added yet</h3>
      <p className="text-gray-500 mb-6 max-w-md mx-auto">
        Start building your course by adding chapters manually or use our AI tools to generate content automatically.
      </p>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
        <button
          onClick={() => document.querySelector('button[aria-label="Add new chapter"]')?.click()}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors inline-flex items-center shadow-sm"
        >
          <Plus className="h-4 w-4 mr-1" />
          Add Chapter Manually
        </button>

        <button
          onClick={aiFeatures.generateCourseOutline}
          disabled={aiFeatures.isGeneratingOutline}
          className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors inline-flex items-center shadow-sm"
        >
          {aiFeatures.isGeneratingOutline ? (
            <>
              <Loader className="h-4 w-4 mr-1 animate-spin" />
              Generating...
            </>
          ) : (
            <>
              <WandIcon className="mr-1 h-4 w-4" />
              Generate Outline with AI
            </>
          )}
        </button>
      </div>
    </div>
  )
}
